import React, { useEffect, useState } from "react";

interface Props {
    enableThirdPartyCode: boolean;
    scriptSrc: string;
    formID: string;
    loadFormParam1: string;
    loadFormParam2: string;
    loadFormParam3: string;
    loadFormRedirectUrl: string;
    partNumber: string;
    category: string;
    brandName: string;
}

export const EmbedExternalCode: React.FunctionComponent<Props> = ({
    enableThirdPartyCode,
    scriptSrc,
    formID,
    loadFormParam1,
    loadFormParam2,
    loadFormParam3,
    loadFormRedirectUrl,
    partNumber,
    category,
    brandName,
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const marketoScriptId = "mktoForms";
    const formId = loadFormParam3;
    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const categoryName = category?.length > 0 ? category.split("/category/")[1].split("/")[0] : '';
    useEffect(() => {
        if (enableThirdPartyCode && isLoaded === false) {
            loadScript();
        }
        setIsPageLoaded(true);
    }, []);

    useEffect(() => {
        if (isLoaded) {
            let scriptCall = null;
            let scriptDiv = null;
            scriptDiv = document.getElementById("MktoForms2Div");
            if (scriptDiv !== null) {
                scriptDiv.remove();
            }
            scriptDiv = document.createElement("div");
            scriptDiv.id = "MktoForms2Div";
            scriptCall = document.getElementById("MktoForms2Form2");
            if (scriptCall !== null) {
                scriptCall.remove();
            }
            scriptCall = document.createElement("script");
            scriptCall.id = "MktoForms2Form2";
            scriptCall.innerHTML = "";
            scriptCall.innerHTML = `MktoForms2.loadForm("${loadFormParam1}", 
            "${loadFormParam2}", "${loadFormParam3}", 
            function(form){
            document.getElementById("buy1Mod").value = '${partNumber}';
            document.getElementById("productCategory").value = '${categoryName}';
            document.getElementById("buy1MFR").value = '${brandName}';
            form.onSuccess(function(values, followUpUrl)
            {
            location.href = "${loadFormRedirectUrl}";
            return false;
            });
            });`;
            scriptDiv.appendChild(scriptCall);
            document.body.appendChild(scriptDiv);
            // ⬇️ CLEANUP ON UNMOUNT ⬇️
            return () => {
                const div = document.getElementById("MktoForms2Div");
                if (div) { div.remove(); }

                const injectedScript = document.getElementById("MktoForms2Form2");
                if (injectedScript) { injectedScript.remove(); }

                const formEl = document.getElementById(`mktoForm_${loadFormParam3}`);
                if (formEl) { formEl.remove(); }
            };
        }
    }, [isLoaded, formId, isPageLoaded]);

    const loadScript = () => {
        if (enableThirdPartyCode && isLoaded === false && isLoading === false) {
            setIsLoading(true);
            const scriptCall = document.getElementById("mktoForms");
            if (scriptCall !== null) {
                scriptCall.remove();
            }
            const s = document.createElement("script");
            s.id = marketoScriptId;
            s.type = "text/javascript";
            s.async = true;
            s.src = scriptSrc;
            s.onload = () => {
                setIsLoaded(true);
                setIsLoading(false);
            };
            document.getElementsByTagName("head")[0].appendChild(s);
        }
    };

    return (
        <>
            {isLoaded && <form key={`mktoForm_${formId}`} id={`mktoForm_${formId}`}></form>}
        </>
    );
};
